<template>
    <div id="login">
        <h3 class="mt-5 mb-3">{{$t('components.after-login-realm-select.title')}}</h3>
        <hr>
        <div class="alert alert-danger" v-if="hasErrors">
            <div v-for="(error, index) in errors" :key="index">
                {{error}}
            </div>
        </div>
        <p class="text" v-for="(text, index) in $t('components.after-login-realm-select.texts')" :key="index">
            {{text}}
        </p>
        <hr>
        <ul>
            <li class="cursor-pointer" v-for="(realm, index) in $t('components.after-login-realm-select.realms')"
                :key="index" @click="selectRealm(realm.key)">
                {{realm.name}} <i class="fas fa-chevron-right"></i>
            </li>
        </ul>
    </div>
</template>

<script>
    import RealmApiService from "../../api/realm.api";

    export default {
        name: "AfterLoginRealmSelect",
        data() {
            return {
                errors: [],
            }
        },
        created() {
            if (!this.$store.getters['authStore/canChangeRealm']) {
                return this.$router.push({name: 'app.start'});
            } else {
                this.$parent.$refs.mainTitle.style.display = 'none';
            }
        },
        methods: {
            selectRealm(realm) {
                this.errors = [];
                let loader = this.$loading.show();
                RealmApiService.select(realm)
                    .then(() => {
                        this.$router.push({name: 'app.start'});
                    })
                    .catch(error => {
                        if (!error.response || error.response.data.message !== 'REALM_ERROR') {
                            this.errors.push(this.$t('whoops'));
                        } else {
                            this.errors = error.response.data.payload.realm;
                        }
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    });
            }
        },

        computed: {
            hasErrors() {
                return this.errors.length > 0;
            }
        }
    }
</script>

<style scoped>
    .text {
        font-size: 16px;
    }

    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    li {
        margin-bottom: 15px;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .cursor-pointer:hover {
        color: #b89453;
    }
</style>
